export default "__VITE_ASSET__D2WXr2N3__"